'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const TEMPLATES = {
    APP_TOUCHPOINT: 'appTouchpoint',
    APP_TOUCHPOINT_CHEKIN: 'appTouchpointCheckin',
};

const appTouchpointOptions = (template) => ({
    template,
});

module.exports = createWidgetFactory({
    name: 'app_touchpoint',
    viewClass: require('./view'),
    options: {
        'app-touchpoint': appTouchpointOptions(TEMPLATES.APP_TOUCHPOINT),
        'app-touchpoint-register': appTouchpointOptions(TEMPLATES.APP_TOUCHPOINT),
        'app-touchpoint-findyourbooking': appTouchpointOptions(TEMPLATES.APP_TOUCHPOINT),
        'app-touchpoint-resultsbottom': appTouchpointOptions(TEMPLATES.APP_TOUCHPOINT),
        'app-touchpoint-betweenresults': appTouchpointOptions(TEMPLATES.APP_TOUCHPOINT),
        'app-touchpoint-mytripsdetails': appTouchpointOptions(TEMPLATES.APP_TOUCHPOINT),
        'app-touchpoint-mytripswithbookings': appTouchpointOptions(TEMPLATES.APP_TOUCHPOINT),
        'app-touchpoint-mytripswithoutbookings': appTouchpointOptions(TEMPLATES.APP_TOUCHPOINT),
        'app-touchpoint-checkin': appTouchpointOptions(TEMPLATES.APP_TOUCHPOINT_CHEKIN),
    },
});
